/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SortOptionDto
 */
export interface SortOptionDto {
    /**
     * Field to sort by
     * @type {string}
     * @memberof SortOptionDto
     */
    field: string;
    /**
     * 
     * @type {string}
     * @memberof SortOptionDto
     */
    order: SortOptionDtoOrderEnum;
}


/**
 * @export
 */
export const SortOptionDtoOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type SortOptionDtoOrderEnum = typeof SortOptionDtoOrderEnum[keyof typeof SortOptionDtoOrderEnum];


/**
 * Check if a given object implements the SortOptionDto interface.
 */
export function instanceOfSortOptionDto(value: object): value is SortOptionDto {
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function SortOptionDtoFromJSON(json: any): SortOptionDto {
    return SortOptionDtoFromJSONTyped(json, false);
}

export function SortOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'],
        'order': json['order'],
    };
}

export function SortOptionDtoToJSON(json: any): SortOptionDto {
    return SortOptionDtoToJSONTyped(json, false);
}

export function SortOptionDtoToJSONTyped(value?: SortOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'order': value['order'],
    };
}

